import { render, staticRenderFns } from "./RefEditor.vue?vue&type=template&id=510ae4a2"
import script from "./RefEditor.vue?vue&type=script&lang=js"
export * from "./RefEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports